import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

// Async thunk for fetching hashtags
export const fetchHashtags = createAsyncThunk(
  'hashtagsAnalyzer/fetchHashtags',
  async ({ text, filters }, { rejectWithValue }) => {
    try {
      const response = await apiCall('/get-hashtags', 'POST', { text, filters });
      // Check if the response contains an error
      if (response.error) {
        return rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      return rejectWithValue('Error fetching hashtags');
    }
  }
);

const hashtagsSlice = createSlice({
  name: 'hashtagsAnalyzer',
  initialState: {
    hashtags: [], // List of generated hashtags
    loading: false, // API request state
    error: null, // Error message for failed requests
  },
  reducers: {
    updateHashtags: (state, action) => {
      state.hashtags = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHashtags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHashtags.fulfilled, (state, action) => {
        state.loading = false;
        // Safely extract hashtags from the response
        state.hashtags = Array.isArray(action.payload?.hashtags) ? action.payload.hashtags : [];
      })
      .addCase(fetchHashtags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'An unexpected error occurred while fetching hashtags';
      });
  },
});

// Reusable selectors
export const selectHashtags = (state) => state.hashtagsAnalyzer.hashtags;
export const selectLoading = (state) => state.hashtagsAnalyzer.loading;
export const selectError = (state) => state.hashtagsAnalyzer.error;

export const { updateHashtags } = hashtagsSlice.actions;

export default hashtagsSlice.reducer;
